import { useEffect } from "react";
import type { HttpAgent } from "@ag-ui/client";
import { invalidateAllSkillLists } from "~/services/skills";

const SKILL_TOOL_NAMES = new Set(["create_skill", "update_skill", "delete_skill"]);

/**
 * Subscribes to AG-UI tool call events from the agent and triggers a skills
 * refresh whenever the backend agent completes a create_skill, update_skill,
 * or delete_skill tool call. This keeps the skills dropdown — and any other
 * mounted skill-list surface (settings tabs, library picker) — in sync when
 * the agent autonomously modifies skills during a conversation.
 *
 * `agentId` gates the subscription: a null/undefined value means there is
 * no agent context yet, so there's nothing to listen to.
 */
export function useSkillSync(agent: HttpAgent, agentId: string | null | undefined) {
  useEffect(() => {
    if (!agentId) return;

    const sub = agent.subscribe({
      onToolCallEndEvent: ({ toolCallName }) => {
        if (SKILL_TOOL_NAMES.has(toolCallName)) {
          invalidateAllSkillLists().catch((err) =>
            console.error("[useSkillSync] Failed to refresh skills:", err)
          );
        }
      },
    });

    return () => sub.unsubscribe();
  }, [agent, agentId]);
}
